var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "footer-content" }, [
    _c("div", { staticClass: "footer-box text-center" }, [
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [_vm._v("\n      " + _vm._s(_vm.$t("footer.brand")) + "\n    ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit("show::modal", "terms-policy-modal")
                }
              }
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("footer.terms")) + "\n      ")]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit("show::modal", "privacy-policy-modal")
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.privacy")) + "\n      "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass:
                "typography--body-3 typography--color-secondary passive-link-btns clickable",
              on: {
                click: function($event) {
                  return _vm.$root.$emit(
                    "show::modal",
                    "operation-policy-modal"
                  )
                }
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.operation")) + "\n      "
              )
            ]
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "typography--body-3 typography--color-secondary" },
        [
          _c(
            "a",
            {
              staticClass: "typography--body-3 typography--color-secondary",
              attrs: {
                href:
                  "http://support.classting.com/hc/ko/sections/115000081194-%ED%81%B4%EB%9E%98%EC%8A%A4%ED%8C%85-%EB%9F%AC%EB%8B%9D-%EC%82%AC%EC%9A%A9%EB%B2%95",
                target: "_blank"
              }
            },
            [
              _vm._v(
                "\n        " + _vm._s(_vm.$t("footer.support")) + "\n      "
              )
            ]
          )
        ]
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      [
        _c("PolicyModal", {
          attrs: {
            id: "terms-policy-modal",
            title: _vm.$t("footer.terms"),
            "policy-id": "terms"
          }
        }),
        _vm._v(" "),
        _c("PolicyModal", {
          attrs: {
            id: "privacy-policy-modal",
            title: _vm.$t("footer.privacy"),
            "policy-id": "privacy"
          }
        }),
        _vm._v(" "),
        _c("PolicyModal", {
          attrs: {
            id: "operation-policy-modal",
            title: _vm.$t("footer.operation"),
            "policy-id": "operation"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-98417144", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98417144","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterContent.vue
// module id = jT7j
// module chunks = 1